/** Shared size for list and calendar toolbar controls. */
export const TOOLBAR_CONTROL_HEIGHT = 36;

export const toolbarControlHeightSx = {
  height: TOOLBAR_CONTROL_HEIGHT,
  minHeight: TOOLBAR_CONTROL_HEIGHT,
  maxHeight: TOOLBAR_CONTROL_HEIGHT,
} as const;

export const toolbarSearchFieldSx = {
  "& .MuiOutlinedInput-root": {
    ...toolbarControlHeightSx,
    boxSizing: "border-box",
    borderRadius: "4px",
    fontSize: "0.875rem",
    paddingLeft: "4px",
    paddingRight: "4px",
  },
  "& .MuiOutlinedInput-input": {
    padding: "0 8px",
    height: TOOLBAR_CONTROL_HEIGHT,
    boxSizing: "border-box",
  },
  "& .MuiInputBase-adornedStart": { paddingLeft: "4px" },
} as const;

/** Production module chrome, applied only by an opted-in shared toolbar. */
export const productionToolbarSx = {
  alignItems: "center",
  "& .MuiButton-root": {
    ...toolbarControlHeightSx,
    minWidth: TOOLBAR_CONTROL_HEIGHT,
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: 0,
  },
  "& .MuiFab-root": { ...toolbarControlHeightSx, width: TOOLBAR_CONTROL_HEIGHT, minWidth: TOOLBAR_CONTROL_HEIGHT },
  "& > .MuiIconButton-root, & > div > .MuiIconButton-root": {
    ...toolbarControlHeightSx,
    width: TOOLBAR_CONTROL_HEIGHT,
    minWidth: TOOLBAR_CONTROL_HEIGHT,
  },
  "& .MuiFormControl-root": { marginTop: "0 !important", marginBottom: "0 !important" },
  "& .MuiOutlinedInput-root": { ...toolbarControlHeightSx, fontSize: "0.875rem" },
  "& .MuiOutlinedInput-input": { height: TOOLBAR_CONTROL_HEIGHT, boxSizing: "border-box", py: 0 },
} as const;
